import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import BackgroundImage from "gatsby-background-image"
import Testimonials from "../components/index/testimonials"
import QuestionsAndAnswers from "../components/wedding/qAndA"
import MiniGallery from "../components/global/miniGallery"

const WeddingPage = ({ data }) => {
  return (
    <React.Fragment>
      <SEO
        title="Wedding Photography
    "
      />
      <Layout isThereAHeroImage={true}>
        <section className="bg-dark">
          <div className="container">
            <div
              style={{ height: "50vh" }}
              className="row align-items-center my-5 py-5"
            >
              <div className="col-12 col-md-6 ">
                <h1 className="text-white display-3">Wedding</h1>
                <h2 className="text-muted display-4">Photography</h2>
              </div>
              <div className="col-12 col-md-6">
                <Img
                  style={{ maxHeight: `50vh` }}
                  fixed={data.intro.childImageSharp.fixed}
                />
              </div>
            </div>
          </div>
        </section>
        <section className="container my-5 pt-5">
          <div className="row py-5 my-5">
            <div className="col-12 col-md-6">
              <h2>Three things I do to make your wedding day less stressful</h2>
              <ol className="p-3">
                <li>
                  Use my quirks and sarcasm to put you at ease and take your
                  mind off the stress.
                </li>
                <li>
                  Help you have a clear timeline for your day and give you
                  realistic expectations of how much time things will actually
                  take on your special day.
                </li>
                <li>
                  Be there for all your needs, even the ones not related to
                  photography. Need deodorant? I’m there. Whatever it is I got
                  you.
                </li>
              </ol>
            </div>
            <div className="col-12 col-md-6">
              <p>
                There is no denying that weddings are stressful events. With a
                lot of practice and patience photographing weddings over the
                years I have mastered the art of putting people at ease on their
                special day. Just as I have learned to accept my own quirks I
                have turned these personality traits into an advantage that
                allow me to make clients feel comfortable and relaxed. In my
                work I strive to photograph couples that are thoughtful, quirky,
                and spirited, all while creating a wedding experience that is
                stress free and fun. By doing this I am able to capture my
                clients at their very best. When you take away the pressures of
                the world you are able to truly feel joy and trust me it shows
                in the photos. In my life I value relationships and with my
                clients I try to make each and every one feel like a friend
                rather than a business transaction. Through developing these
                relationships I’m able to break down the awkwardness, relieve
                stress and create an ideal environment for photography. I want
                you to know that I will be there for more than just your wedding
                photography needs. I truly care about my clients. Forgot your
                deodorant? Don’t worry you can borrow mine. Need someone to
                bustle your dress? I got it! Just need someone to crack some
                jokes with? Oh you know I got that. Trust me and everything will
                turn out great.
              </p>

              <p>
                For me weddings are all about allowing couples to be their
                authentic selves. I know that word gets thrown out a lot, but I
                want my couples to feel free to be a little weird and not care.
                My approach is definitely more energetic than romantic. I LOVE a
                good party and often times that’s my favorite part of weddings.
                I love bringing out that joy and the thoughtful moments of your
                day. My couples are real people, that aren't regularly
                photographed. I've worked hard to find ways to make my clients
                feel comfortable in front of the camera and that is exactly what
                I will do for you by providing the right environment. Creating a
                carefree wedding can be a difficult task but by being my weird
                and caring self seems to do the job for me! Does that sound like
                something you want on your wedding day? If so contact me!
              </p>
            </div>
          </div>
        </section>
        <BackgroundImage
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: `50vh` }}
          fluid={data.price.childImageSharp.fluid}
        >
          <div className="text-center text-white">
            <h1 className="text-center text-uppercase display-4">
              Prices Starting at $3,500
            </h1>
            <p className="lead">
              For couples who want to ditch the stress and have the best day
              ever
            </p>
            <Link to="/contact">
              <button
                type="button"
                className="btn btn-outline-light"
                style={{ cursor: "pointer" }}
              >
                Contact Me Today
              </button>
            </Link>
          </div>
        </BackgroundImage>
        <div className="py-5" />
        <Testimonials dataImage={data.testimonialsImage.edges} />
        <div className="py-5" />
        <QuestionsAndAnswers />
        <div className="py-5" />
        <MiniGallery data={data.miniGallery.edges} />
        <div className="py-5" />
        <section className="py-5 bg-info">
          <div className="container text-center">
            <h2 className="text-white text-uppercase">
              Wanna Catch Up On Recent Wedding Stories?
            </h2>
            <Link to="/blog">
              <button className="btn btn-outline-light mt-3">
                View The Wedding Blog
              </button>
            </Link>
          </div>
        </section>
        <section className="py-5 bg-dark">
          <div className="container">
            <div className="d-flex flex-column flex-md-row justify-content-between">
              <div>
                <h2 className="text-uppercase text-white">
                  Resources To Help You Out
                </h2>
                <p className="text-muted">Selected tips and tricks</p>
              </div>
              <Link to="/blog">
                <button className="btn btn-outline-light">
                  View The Resource Blog
                </button>
              </Link>
            </div>
            <div className="row mt-3">
              {data.resourcesImage.edges.map(image => {
                return (
                  <div
                    key={image.node.id}
                    className="col-12 col-md-6 mt-3 mt-md-0"
                  >
                    <Img
                      style={{ height: "15rem" }}
                      fluid={image.node.childImageSharp.fluid}
                    />
                    <h3 className="text-white h5 mt-3">{image.node.name}</h3>
                  </div>
                )
              })}
            </div>
          </div>
        </section>
        <section className="text-center py-5 bg-light">
          <h2 className="text-uppercase">Ready to Chat?</h2>
          <div className="py-3" />
          <Link to="/contact">
            <button
              type="button"
              className="btn text-white"
              style={{ background: "rgb(178, 146, 78)", cursor: "pointer" }}
            >
              Contact Me Today
            </button>
          </Link>
        </section>
      </Layout>
    </React.Fragment>
  )
}

export default WeddingPage

export const query = graphql`
  {
    intro: file(relativePath: { eq: "weddingPage/intro.jpg" }) {
      childImageSharp {
        fixed(width: 500, height: 500) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    price: file(relativePath: { eq: "weddingPage/price.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    testimonialsImage: allFile(
      filter: { relativeDirectory: { eq: "indexPage/testimonials" } }
    ) {
      edges {
        node {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    miniGallery: allFile(
      filter: { relativeDirectory: { eq: "weddingPage/miniGallery" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    resourcesImage: allFile(
      filter: { relativeDirectory: { eq: "weddingPage/blogResources" } }
    ) {
      edges {
        node {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
